module.exports = "/images/chat.svg?add6dd65230ac465391d20f586cdd2d1";